export default __webpack_public_path__ + "static/media/g14.0edefd76.jpg";